import {
    useRef
} from 'react';

import { SimpleGrid, Text } from '@mantine/core';
import { Link } from 'react-router-dom';

import { useMeters } from '../hooks/useMeters.ts';
import { useMetersSelection } from '../hooks/useMetersSelection.ts';

import {
    MantineDataTable,
    TableSearchForm,
} from '@flexinet/ui-components';
import { DataTableColumn } from "mantine-datatable";
import { DataTableTokenPagination } from "../../../components/DataTableTokenPagination.tsx";
import { Meter } from '../types';

export const RecordsTable = () => {
    const {selectedRecords, setSelectedRecords} = useMetersSelection();

    const {
        items,
        totalCount,
        loading,
        nextToken,
        fetchRecords,
        handleFilterByKeyword
    } = useMeters();



    const scrollViewportRef = useRef<HTMLDivElement>(null);

    const columns: DataTableColumn<Meter>[] = [
        {
            accessor: 'name',
            title: 'Meter',
            render: (record: Meter) => (
                <Link to={`/meters/${record.id}`} style={{ textDecoration: 'none' }}>
                    <Text c="blue" style={{ cursor: 'pointer' }}>
                        {record.name}
                    </Text>
                </Link>
            )
        },
        { accessor: 'created', title: 'Created' },
    ];

    return (
        <SimpleGrid verticalSpacing='xl' m='sm'>
            <TableSearchForm handleFilterByKeyword={handleFilterByKeyword} />

            <MantineDataTable
                columns={columns}
                records={items}
                selectedRecords={selectedRecords}
                onSelectedRecordsChange={setSelectedRecords}
                fetching={loading}
                onScrollToBottom={() => fetchRecords()}
                scrollViewportRef={scrollViewportRef}
                withTableBorder={true}
            />

            <DataTableTokenPagination totalCount={totalCount.toString()} nextToken={nextToken} handleLoadMore={fetchRecords} />

        </SimpleGrid>
    );
};